module.exports = __webpack_public_path__ + "static/img/section04-02@w.548d044.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/serveone-renewal/section04-02@w.jpg
// module id = Lr6S
// module chunks = 0